import { render, staticRenderFns } from "./DeleteReportCustomComponentRel.vue?vue&type=template&id=25f14002"
import script from "./DeleteReportCustomComponentRel.vue?vue&type=script&lang=js"
export * from "./DeleteReportCustomComponentRel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports